export default __webpack_public_path__ + "static/media/slide-1.70a1b61b.jpg";